import { AxiosError } from "axios";
import { getApi, postApi, postApiParams } from "../CreateApi";
import { BodyPostEmail, ResponseGetEmails } from "./interfaceEmail";

export const getAllEmails = async (): Promise<ResponseGetEmails[]> => {
    try {
        const data = await getApi('/emails');
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetEmails[];
    }
}


export const postSendEmailStudent = async (body: BodyPostEmail): Promise<any> => {
    try {
        const data = await postApi('/emails/student', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const postSendEmailMany = async (bodyPost: any): Promise<any> => {
    const { subject, body, type,studentIds, ...res } = bodyPost

    try {
        const data = await postApiParams('/emails/many', { subject, body, type, studentIds }, res);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getEmailId = async (id: string): Promise<ResponseGetEmails> => {
    try {
        const data = await getApi(`/emails/${id}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetEmails;
    }
}